// @ts-strict-check
import React, { useState, useRef, useCallback } from 'react';
import { createPortal } from 'react-dom';

/** آیکن راهنمای ستون با tooltip که از طریق Portal رندر می‌شود تا توسط overflow جدول بریده نشود */
const ColumnInfoTooltip: React.FC<{ text: string }> = ({ text }) => {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const iconRef = useRef<HTMLSpanElement>(null);

  const updatePosition = useCallback(() => {
    if (!iconRef.current) return;
    const rect = iconRef.current.getBoundingClientRect();
    setPosition({
      top: rect.top - 8,
      left: rect.left + rect.width / 2,
    });
  }, []);

  const show = useCallback(() => {
    updatePosition();
    setVisible(true);
  }, [updatePosition]);

  const hide = useCallback(() => setVisible(false), []);

  return (
    <span className="relative inline-flex items-center justify-center shrink-0 align-middle self-center">
      <span
        ref={iconRef}
        className="inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-[10px] font-bold cursor-help leading-none normal-case"
        style={{
          backgroundColor: 'rgba(var(--accent-cyan-rgb, 6, 182, 212), 0.15)',
          color: 'var(--accent-cyan)',
          border: '1px solid var(--accent-cyan)',
        }}
        role="img"
        aria-label={text}
        tabIndex={0}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
      >
        i
      </span>
      {visible &&
        createPortal(
          <div
            className="fixed z-[9999] w-56 -translate-x-1/2 -translate-y-full rounded-md bg-gray-900 px-3 py-2 text-xs font-normal leading-5 text-white shadow-lg normal-case tracking-normal text-right pointer-events-none"
            style={{ top: position.top, left: position.left, direction: 'rtl' }}
          >
            {text}
          </div>,
          document.body,
        )}
    </span>
  );
};

export default ColumnInfoTooltip;
